export default "__VITE_ASSET__C3FH9sX3__"